// This fields name rule:
// One address: line1; two addresses: line1, line2; three addresses: line1, line21, line22. eg:Malaysia
// One city: city; two citys: city1, city2. eg:Indonesia
// One stateProvinces: stateProvince; two stateProvinces: stateProvince1, stateProvince2. eg:Indonesia

const addressFieldsConfig = {
  country: { autoComplete: 'country' },
  city: { maxLength: 50, autoComplete: 'city' },
  city1: { maxLength: 50, autoComplete: 'city1' },
  city2: { maxLength: 50, autoComplete: 'city2' },
  line1: { maxLength: 255, autoComplete: 'address-line1' },
  line2: { maxLength: 255, autoComplete: 'address-line2' },
  line21: { maxLength: 255, autoComplete: 'address-line2' },
  line22: { maxLength: 255, autoComplete: 'address-line3' },
  stateProvince: { maxLength: 50, autoComplete: 'province' },
  stateProvince1: { maxLength: 50, autoComplete: 'province1' },
  stateProvince2: { maxLength: 50, autoComplete: 'province2' },
  postalCode: { maxLength: 10, autoComplete: 'postal-code' },
};

export default addressFieldsConfig;
